/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

/**
 * Service that watches the active angular-translate language and
 * automatically applies dir="rtl"/lang="fa" (or ltr) to <html> whenever
 * the user switches to a Right-to-Left language such as Persian.
 *
 * PLACE THIS FILE AT:
 *   guacamole/src/main/frontend/src/app/index/services/rtlService.js
 */
angular.module('index').factory('rtlService', [
    '$translate',
    '$rootScope',
    '$document',
    function rtlServiceFactory($translate, $rootScope, $document) {

        'use strict';

        /**
         * ISO 639-1 language codes that use Right-to-Left script.
         * Extend as needed.
         * @type {string[]}
         */
        var RTL_LANGUAGES = ['fa', 'ar', 'he', 'ur', 'ps', 'ku', 'dv', 'ug', 'yi'];

        /**
         * Returns true if the given BCP-47 tag is for an RTL language.
         * @param  {string}  lang
         * @return {boolean}
         */
        function isRTL(lang) {
            if (!lang) { return false; }
            var prefix = lang.toLowerCase().split(/[-_]/)[0];
            return RTL_LANGUAGES.indexOf(prefix) !== -1;
        }

        /**
         * Sets dir= and lang= on <html> and <body> to match the given language.
         * Also toggles the CSS classes guac-rtl / guac-ltr on <html>.
         * @param {string} lang  Active language key (e.g. "fa", "en").
         */
        function applyDirection(lang) {
            var html = $document[0].documentElement;
            var body = $document[0].body;
            var rtl  = isRTL(lang);
            var dir  = rtl ? 'rtl' : 'ltr';

            html.setAttribute('dir',  dir);
            html.setAttribute('lang', lang || 'en');
            if (body) {
                body.setAttribute('dir',  dir);
                body.setAttribute('lang', lang || 'en');
            }

            // CSS helper classes — used by custom stylesheets if needed
            if (rtl) {
                angular.element(html).addClass('guac-rtl').removeClass('guac-ltr');
            } else {
                angular.element(html).addClass('guac-ltr').removeClass('guac-rtl');
            }
        }

        // Apply direction based on the language already selected at startup
        applyDirection($translate.use() || $translate.preferredLanguage());

        // Re-apply whenever the user switches language at runtime
        $rootScope.$on('$translateChangeSuccess', function(event, data) {
            applyDirection(data.language);
        });

        return { isRTL: isRTL, applyDirection: applyDirection };
    }
]);
